export default api => ({
    list: params => api.get(`/entity-views`, params),
    create: params => api.post(`/entity-views`, params),
    get: ({ viewId }) => api.get(`/entity-views/${viewId}`),
    update: ({ viewId, ...params }) => api.patch(`/entity-views/${viewId}`, params),
    remove: ({ viewId }) => api.delete(`/entity-views/${viewId}`),
})
